import { defineRecipe } from '@chakra-ui/react'

const feedback = {
    border: 'none',
    fontSize: '12px',
    fontWeight: 'bold',
}

export const buttonRecipe = defineRecipe({
    base: {
        _hover: {
            borderColor: 'inherit',
        },
        _focus: {
            boxShadow: 'none',
            outline: 'none',
        },
        _focusVisible: {
            boxShadow: 'none',
            outline: 'none',
        },
    },
    variants: {
        variant: {
            outline: {
                color: 'dark.700',
                borderColor: 'dark.300',
                backgroundColor: 'white',
                fontWeight: 'bold',
                _hover: {
                    borderColor: 'dark.500',
                },
                _dark: {
                    color: 'white',
                    borderColor: 'dark.500',
                    backgroundColor: 'black',
                    _hover: {
                        backgroundColor: 'dark.100',
                    },
                },
            },
            feedback: {
                border: 'none',
                fontSize: '12px',
                _light: {
                    color: 'dark.700',
                    _hover: {
                        backgroundColor: 'gray.100',
                    },
                    _active: {
                        backgroundColor: 'gray.50',
                    },
                },
                _dark: {
                    color: 'white',
                    _hover: {
                        backgroundColor: 'dark.700',
                    },
                    _active: {
                        backgroundColor: 'dark.700',
                    },
                },
            },
            primary: {
                border: 'none',
                borderRadius: '8px',
                fontSize: '12px',
                padding: '12px 20px',
                _light: {
                    backgroundColor: 'dark.700',
                    color: 'white',
                    _hover: {
                        backgroundColor: 'dark.600',
                        boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(43, 43, 42, 0.3)',
                        color: 'white',
                        _disabled: {
                            backgroundColor: 'gray.400',
                            boxShadow: 'none',
                            color: 'rgba(84, 79, 64, 0.7)',
                            opacity: 1,
                        },
                    },
                    _active: {
                        backgroundColor: 'dark.600',
                        boxShadow: 'none',
                        color: 'white',
                    },
                    _disabled: {
                        backgroundColor: 'gray.400',
                        color: 'rgba(84, 79, 64, 0.7)',
                        opacity: 1,
                    },
                },
                _dark: {
                    backgroundColor: 'surface.dark',
                    color: 'dark.700',
                    _hover: {
                        backgroundColor: 'rgba(255, 255, 255, 0.68)',
                        boxShadow: '0px 1px 3px 1px rgba(255, 255, 255, 0.15), 0px 1px 2px 0px rgba(255, 255, 255, 0.3)',
                        _disabled: {
                            backgroundColor: 'white',
                            boxShadow: 'none',
                        },
                    },
                    _active: {
                        backgroundColor: 'rgba(255, 255, 255, 0.68)',
                        boxShadow: 'none',
                        color: 'dark.700',
                    },
                    _disabled: {
                        backgroundColor: 'white',
                        boxShadow: 'none',
                        color: 'dark.700',
                        opacity: 0.3,
                    },
                },
            },
            send: {
                border: '1px solid',
                borderRadius: '4px',
                height: '56px',
                minWidth: '56px',
                padding: 0,
                _light: {
                    backgroundColor: 'dark.700',
                    borderColor: 'dark.700',
                    _hover: {
                        backgroundColor: 'dark.600',
                        borderColor: 'dark.600',
                        _disabled: {
                            opacity: 1,
                            color: 'white',
                            backgroundColor: 'dark.600',
                            borderColor: 'dark.600',
                        },
                    },
                    _active: {
                        backgroundColor: 'dark.700',
                        borderColor: 'dark.700',
                    },
                    _disabled: {
                        opacity: 1,
                        color: 'white',
                        backgroundColor: 'dark.600',
                        borderColor: 'dark.600',
                    },
                },
                _dark: {
                    backgroundColor: 'surface.dark',
                    borderColor: 'surface.dark',
                    color: 'dark.700',
                    _hover: {
                        backgroundColor: 'surface.dark',
                        borderColor: 'surface.dark',
                        _disabled: {
                            opacity: 1,
                            color: 'dark.700',
                            backgroundColor: 'surface.dark',
                            borderColor: 'surface.dark',
                        },
                    },
                    _active: {
                        backgroundColor: 'surface.dark',
                        borderColor: 'surface.dark',
                    },
                    _disabled: {
                        opacity: 1,
                        color: 'dark.700',
                        backgroundColor: 'surface.dark',
                        borderColor: 'surface.dark',
                    },
                },
            },
            settings: {
                border: 'none',
                fontSize: '14px',
                fontWeight: 'regular',
                height: '32px',
                padding: '6px 8px',
                'span:first-of-type': {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                },

                _light: {
                    _hover: {
                        backgroundColor: 'dark.700',
                        color: 'white',
                    },
                    _active: {
                        backgroundColor: 'dark.700',
                        color: 'white',
                    },
                },
                _dark: {
                    _hover: {
                        _disabled: {
                            opacity: 1,
                            color: 'white',
                        },
                    },
                    _active: {
                        backgroundColor: 'surface.dark',
                        color: 'dark.700',
                    },
                },
            },
            secondary: {
                border: '1px solid',
                borderRadius: '8px',
                fontSize: '12px',
                padding: '12px 20px',
                _light: {
                    borderColor: 'dark.700',
                    color: 'dark.700',
                    _hover: {
                        backgroundColor: 'gray.50',
                        boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(43, 43, 42, 0.3)',
                    },
                    _active: {
                        backgroundColor: 'gray.50',
                        boxShadow: 'none',
                    },
                },
                _dark: {
                    borderColor: 'white',
                    boxShadow: 'none',
                    color: 'white',
                    _hover: {
                        backgroundColor: 'dark.700',
                        boxShadow: '0px 1px 3px 1px rgba(255, 255, 255, 0.15), 0px 1px 2px 0px rgba(255, 255, 255, 0.3)',
                    },
                    _active: {
                        backgroundColor: 'dark.700',
                        boxShadow: 'none',
                    },
                },
            },
            mainSettings: {
                border: '1px solid',
                padding: '12px 20px',
                borderRadius: '16px',
                fontSize: '14px',
                letterSpacing: '0.25px',
                height: '16px',
                fontWeight: 'normal',
                cursor: 'pointer',
                color: 'dark.700',
                _light: {
                    borderColor: 'gray.250',
                    _hover: {
                        backgroundColor: 'white',
                    },
                    _active: {
                        backgroundColor: 'dark.700',
                        color: 'white',
                    },
                },
                _dark: {
                    borderColor: 'white',
                    boxShadow: 'none',
                    color: 'white',
                    _hover: {
                        backgroundColor: 'inherit',
                    },
                    _active: {
                        backgroundColor: 'white',
                        color: 'dark.700',
                    },
                },
            },
            newChat: {
                border: '1px solid',
                fontSize: '12px',
                padding: '12px 17px',
                _light: {
                    borderColor: 'dark.700',
                    color: 'dark.700',
                    _hover: {
                        backgroundColor: 'gray.50',
                        boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(43, 43, 42, 0.3)',
                        _disabled: {
                            boxShadow: 'none',
                        },
                    },
                    _active: {
                        backgroundColor: 'gray.50',
                        boxShadow: 'none',
                    },
                },
                _dark: {
                    borderColor: 'white',
                    color: 'white',
                    _hover: {
                        backgroundColor: 'dark.600',
                        boxShadow: '0px 1px 3px 1px rgba(255, 255, 255, 0.15), 0px 1px 2px 0px rgba(255, 255, 255, 0.3)',
                        color: 'white',
                        _disabled: {
                            backgroundColor: 'gray.400',
                            boxShadow: 'none',
                            color: 'rgba(84, 79, 64, 0.7)',
                            opacity: 1,
                        },
                    },
                },
            },
            square: {
                border: '1px solid',
                fontSize: '12px',
                padding: '0',
                shadow: 'none',
                borderRadius: '8px',
                _light: {
                    borderColor: 'dark.700',
                    _hover: {
                        shadow: 'none',
                        backgroundColor: 'dark.700',
                        borderColor: 'dark.700',
                        _disabled: {
                            backgroundColor: 'dark.700',
                            boxShadow: 'none',
                            opacity: 0.6,
                        },
                    },
                },
                _dark: {
                    borderColor: 'white',
                    _hover: {
                        shadow: 'none',
                        backgroundColor: 'white',
                        borderColor: 'white',
                        _disabled: {
                            backgroundColor: 'white',
                            boxShadow: 'none',
                            opacity: 0.7,
                        },
                    },
                },
            },
            squareNoBorder: {
                border: '0px',
                fontSize: '12px',
                padding: '0',
                borderRadius: '8px',
                _light: {
                    _hover: {
                        color: 'white',
                        backgroundColor: 'dark.700',
                        boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(43, 43, 42, 0.3)',
                        _disabled: {
                            backgroundColor: 'dark.700',
                            boxShadow: 'none',
                            opacity: 0.6,
                        },
                    },
                },
                _dark: {
                    _hover: {
                        backgroundColor: 'white',
                        boxShadow: '0px 1px 3px 1px rgba(255, 255, 255, 0.15), 0px 1px 2px 0px rgba(255, 255, 255, 0.3)',
                        _disabled: {
                            backgroundColor: 'white',
                            boxShadow: 'none',
                            opacity: 0.7,
                        },
                    },
                },
            },
            menu: {
                backgroundColor: 'transparent',
                border: 'none',
                _active: {
                    backgroundColor: 'transparent',
                },
                _hover: {
                    backgroundColor: 'transparent',
                },
            },
            menuTrigger: {
                border: 'none',
                _light: {
                    color: 'black',
                    _hover: {
                        backgroundColor: 'gray.100',
                    },
                    _open: {
                        backgroundColor: 'gray.50',
                    },
                },
                _dark: {
                    _hover: {
                        backgroundColor: 'dark.700',
                    },
                    _open: {
                        backgroundColor: 'dark.700',
                    },
                },
            },
            copy: {
                border: 'none',
                _light: {
                    _hover: {
                        backgroundColor: 'gray.100',
                    },
                    _active: {
                        backgroundColor: 'gray.50',
                    },
                },
                _dark: {
                    _hover: {
                        backgroundColor: 'dark.700',
                    },
                },
            },
            negativeFeedback: {
                ...feedback,
                backgroundColor: 'transparent',
                color: 'status.error',
                _light: {
                    _active: {
                        backgroundColor: 'status.errorLight',
                    },
                    _hover: {
                        backgroundColor: 'status.errorLight',
                    },
                },
                _dark: {
                    _active: {
                        backgroundColor: 'dark.700',
                    },
                    _hover: {
                        backgroundColor: 'dark.700',
                    },
                },
                _active: {
                    backgroundColor: 'gray.50',
                },
            },
            positiveFeedback: {
                ...feedback,
                backgroundColor: 'transparent',
                color: 'tertiaryGreen.700',
                _light: {
                    _active: {
                        backgroundColor: 'tertiaryGreen.50',
                    },
                    _hover: {
                        backgroundColor: 'tertiaryGreen.50',
                    },
                },
                _dark: {
                    _active: {
                        backgroundColor: 'dark.700',
                    },
                    _hover: {
                        backgroundColor: 'dark.700',
                    },
                },
            },
            reject: {
                ...feedback,
                backgroundColor: 'status.error',
                color: 'white',
                _active: {
                    backgroundColor: 'status.error',
                },
                _light: {
                    _hover: {
                        boxShadow: '0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(43, 43, 42, 0.3)',
                        backgroundColor: 'status.error',
                    },
                    _disabled: {
                        boxShadow: 'none',
                    },
                },
                _dark: {
                    _hover: {
                        backgroundColor: 'status.error',
                        boxShadow: '0px 1px 3px 1px rgba(255, 255, 255, 0.15), 0px 1px 2px 0px rgba(255, 255, 255, 0.3)',
                        _disabled: {
                            boxShadow: 'none',
                        },
                    },
                },
            },
            tooltipIcon: {
                cursor: 'default',
                border: 'none',
                outline: 'none',
                backgroundColor: 'transparent',
                padding: 0,
                margin: 0,
                borderRadius: 0,
                lineHeight: 1,
                height: 'unset',
                minWidth: 'unset',
                minHeight: 'unset',
            },
        },
    },
})
